import {CSSProperties} from "react";

export function MyLoadingSpinner({isLoading = false, isUpdating = false}){
  if(isLoading){
    return (<div style={styles.loadingSpinnerBackground}>
        <div style={styles.loadingSpinner}>
          <div>{"Loading"}</div>
        </div>
      </div>);
  }
  if(isUpdating){
    return (<div style={styles.loadingSpinner}>
        <div>{"Loading"}</div>
      </div>);
  }
  return null;
}

interface MyStyles {
  loadingSpinner: CSSProperties;
  loadingSpinnerBackground: CSSProperties;
}

const styles: MyStyles = {
  loadingSpinner: {
    zIndex: 2000
  },
  loadingSpinnerBackground: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(121, 121, 121, 0.8)',
    zIndex: 2000,
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};
